<style lang="scss">
.profile-page {
    &__card {
      min-height: 375px;
    }

  .tabs {
    flex-basis: 89%;
    ul[role="tablist"] {
      padding: 0 !important;
    }

    a[role="tab"] {
      display: none;
    }
  }
}
</style>

<template>
  <div class="profile-page">
    <b-card no-body class="mb-0 profile-page__card" v-if="profile">
      <section class="d-inline-flex">
        <div class="custom-tab-nav card-body pr-0">
          <b-button class="full-width" @click="tabs = $index" v-for="(item, $index) in tabItems" :key="$index" :variant="tabs === $index ? 'primary' : 'link'">{{item}}</b-button>
        </div>
        <b-tabs pills card vertical lazy v-model="tabs" class="">
          <b-tab key="basic-details">
            <profile-details @refresh="getProfile" :profile="profile"></profile-details>
          </b-tab>
          <b-tab key="security">
            <profile-security @refresh="getProfile"></profile-security>
          </b-tab>
        </b-tabs>
      </section>
    </b-card>

    <section v-if="!profile && !loading">
      <p>Profile details not found</p>
    </section>
  </div>
</template>

<script>
  import ProfileDetails from '@/views/profile/sections/ProfileDetails.vue';
  import ProfileSecurity from '@/views/profile/sections/ProfileSecurity.vue';
  import PrisonUsersService from '@/services/PrisonUsersService';

  export default {
    name: 'Profile',
    components: {
      ProfileDetails,
      ProfileSecurity,
    },
    props: {},
    data() {
      return {
        loading: false,
        profile: null,
        tabs: 0,
        tabItems: ['Your Details', 'Password'],
      };
    },
    mounted() {
      this.getProfile();
    },
    methods: {
      getProfile() {
        this.tabs = 0;
        this.loading = true;
        PrisonUsersService.getUser().then(res => {
          this.profile = res.data;
        }).catch(err => {
          const res = err.response;
          let errorText = 'Could not get profile, please refresh and try again';

          if (res && res.data.error) {
            errorText = res.data.error;
          }

          this.$toast.error(errorText, {
            toastClassName: ['toast-std', 'warning-toast'],
          });
        }).finally(() => {
          this.loading = false;
        });
      },
    },
  };
</script>
